"use strict";

var _slicedToArray = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = exports.AccordionVariant = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Layout = require("../Layout");

var _AccordionVariantItem = _interopRequireDefault(require("./AccordionVariantItem"));

var _ComponentWrapper = _interopRequireDefault(require("../ComponentWrapper"));

var _AccordionVariant = require("./AccordionVariant.style");

var _Typography = require("../Typography");

var AccordionVariant = function AccordionVariant(_ref) {
  var title = _ref.title,
      content = _ref.content,
      cta = _ref.cta,
      id = _ref.id,
      onAccordionChange = _ref.onAccordionChange,
      columnWidth = _ref.columnWidth,
      _ref$activeTabIndex = _ref.activeTabIndex,
      activeTabIndex = _ref$activeTabIndex === void 0 ? null : _ref$activeTabIndex;
  var isCtaShown = (content === null || content === void 0 ? void 0 : content.length) >= 8 && !!cta.url && !!cta.label;

  var _ref2 = (0, _react.useState)(activeTabIndex),
      _ref3 = _slicedToArray(_ref2, 2),
      activeTabIndexValue = _ref3[0],
      setActiveTabIndex = _ref3[1];

  function activateTab(index, heading) {
    setActiveTabIndex(activeTabIndexValue === index ? -1 : index);
    onAccordionChange(heading);
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ComponentWrapper.default, {
    columnWidth: columnWidth,
    id: id
  }, /*#__PURE__*/_react.default.createElement(_AccordionVariant.AccordionVariantTitleWrap, null, title && /*#__PURE__*/_react.default.createElement(_Typography.PageTitle, {
    size: "large"
  }, title), isCtaShown && /*#__PURE__*/_react.default.createElement(_AccordionVariant.AccordionVariantButton, Object.assign({
    endIcon: "ChevronRight",
    size: "small",
    variant: "link"
  }, cta), cta.label)), /*#__PURE__*/_react.default.createElement(_Layout.Grid, null, /*#__PURE__*/_react.default.createElement(_Layout.Column, {
    width: columnWidth
  }, /*#__PURE__*/_react.default.createElement(_AccordionVariant.AccordionVariantCardWrapper, {
    role: "tablist"
  }, content === null || content === void 0 ? void 0 : content.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_AccordionVariantItem.default, {
      key: index,
      item: item,
      activeTabIndex: activeTabIndexValue,
      index: index,
      activateTab: activateTab,
      onAccordionChange: onAccordionChange
    });
  }))))));
};

exports.AccordionVariant = AccordionVariant;
AccordionVariant.propTypes = {
  id: _propTypes.default.string,
  title: _propTypes.default.string,
  content: _propTypes.default.arrayOf(_propTypes.default.shape({
    heading: _propTypes.default.string,
    copy: _propTypes.default.string
  })),
  cta: _propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  }),
  columnWidth: _propTypes.default.arrayOf(_propTypes.default.number),
  activeTabIndex: _propTypes.default.number,
  onAccordionChange: _propTypes.default.func
};
AccordionVariant.defaultProps = {
  id: '',
  title: '',
  content: [],
  cta: {
    label: '',
    url: null
  },
  columnWidth: [12],
  activeTabIndex: null,
  onAccordionChange: function onAccordionChange() {}
};
var _default = AccordionVariant;
exports.default = _default;